import { cn } from "@/utils/cn";
import { memo } from "react";

interface ScaleIconProps {
  className?: string;
}

export const ScaleIcon = memo(function ScaleIcon({ className }: ScaleIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("fill-white", className)}
    >
      <path
        d="M22.4466 12.4688L19.4466 4.96875C19.3805 4.80355 19.2579 4.66721 19.1006 4.58409C18.9433 4.50097 18.7615 4.47648 18.5878 4.515L12.75 5.8125V3.75C12.75 3.55109 12.671 3.36032 12.5303 3.21967C12.3897 3.07902 12.1989 3 12 3C11.8011 3 11.6103 3.07902 11.4697 3.21967C11.329 3.36032 11.25 3.55109 11.25 3.75V6.14813L5.08689 7.51781C4.96806 7.54406 4.85741 7.59883 4.76447 7.67739C4.67153 7.75595 4.59911 7.85595 4.55345 7.96875V7.97437L1.55345 15.4688C1.51756 15.5581 1.49941 15.6537 1.50001 15.75C1.50001 17.9353 3.80064 18.75 5.25001 18.75C6.69939 18.75 9.00001 17.9353 9.00001 15.75C9.00062 15.6537 8.98246 15.5581 8.94658 15.4688L6.27376 8.79094L11.25 7.6875V19.5H9.75001C9.5511 19.5 9.36034 19.579 9.21968 19.7197C9.07903 19.8603 9.00001 20.0511 9.00001 20.25C9.00001 20.4489 9.07903 20.6397 9.21968 20.7803C9.36034 20.921 9.5511 21 9.75001 21H14.25C14.4489 21 14.6397 20.921 14.7803 20.7803C14.921 20.6397 15 20.4489 15 20.25C15 20.0511 14.921 19.8603 14.7803 19.7197C14.6397 19.579 14.4489 19.5 14.25 19.5H12.75V13.4259V7.35187L17.5313 6.29062L15.0535 12.4688C15.0176 12.5581 14.9994 12.6537 15 12.75C15 14.9353 17.3006 15.75 18.75 15.75C20.1994 15.75 22.5 14.9353 22.5 12.75C22.5006 12.6537 22.4825 12.5581 22.4466 12.4688ZM5.25001 17.25C4.54408 17.25 3.11626 16.9116 3.00658 15.8775L5.25001 10.2694L7.49345 15.8775C7.38376 16.9116 5.95595 17.25 5.25001 17.25ZM18.75 14.25C18.0441 14.25 16.6163 13.9116 16.5066 12.8775L18.75 7.26937L20.9935 12.8775C20.8838 13.9116 19.456 14.25 18.75 14.25Z"
        fill="white"
      />
    </svg>
  );
});
